import React, { useEffect, useState } from "react";
import InputField from "components/fields/InputField";
import Calculation from "./Calculation";
import Select from "react-tailwindcss-select";
import getSelectClassNames from "components/SelectFieldClasses/SelectFieldClasses";
import userResources from "api/userResources";

const HotelForm = ({
  hotel,
  register,
  errors,
  clearErrors,
  watch,
  setValue,
  getValues,
  control,
  updateData,
}) => {
  const [counties, setCounties] = useState([]);
  const [supplierData, setSupplierData] = useState([]);

  const getSuppliers = async () => {
    try {
      const response = await userResources.supplier();
      const combinedData = response.data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      setSupplierData(combinedData);
    } catch (error) {
      console.log(error);
    }
  };
  const getCountries = async () => {
    try {
      const response = await userResources.countries();
      const combinedData = response.data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      // setCountryFilterData(response.data.data);

      setCounties(combinedData);

      if (updateData) {
        const toBoolean = (value) => {
          if (typeof value === "boolean") return value;
          return String(value).toLowerCase() === "true";
        };

        setValue(
          "hotel.hotelDetails.hotel_name",
          updateData?.hotel?.hotelDetails?.hotel_name
        );
        setValue(
          "hotel.hotelDetails.country",
          Number(updateData?.hotel?.hotelDetails?.country)
        );
        setValue(
          "hotel.hotelDetails.start_date",
          updateData?.hotel?.hotelDetails?.start_date
        );
        setValue(
          "hotel.hotelDetails.end_date",
          updateData?.hotel?.hotelDetails?.end_date
        );
        setValue(
          "hotel.hotelDetails.operator",
          updateData?.hotel?.hotelDetails?.operator
        );
        // hotel calculation update
        // hotel
        setValue(
          `hotel.passengers.adt`,
          Number(updateData?.hotel?.passengers?.adt)
        );
        setValue(
          `hotel.passengers.chd`,
          Number(updateData?.hotel?.passengers?.chd)
        );
        setValue(
          `hotel.passengers.inf`,
          Number(updateData?.hotel?.passengers?.inf)
        );
        setValue(
          `hotel.hotel_from_pax.baseFare.adt1`,
          Number(updateData?.hotel.hotel_from_pax?.baseFare?.adt1)
        );
        setValue(
          `hotel.hotel_from_pax.baseFare.chd1`,
          Number(updateData?.hotel.hotel_from_pax?.baseFare?.chd1)
        );
        setValue(
          `hotel.hotel_from_pax.baseFare.inf1`,
          Number(updateData?.hotel.hotel_from_pax?.baseFare?.inf1)
        );
        setValue(
          `hotel.hotel_from_pax.gstHst.adt1`,
          Number(updateData?.hotel.hotel_from_pax?.gstHst?.adt1)
        );
        setValue(
          `hotel.hotel_from_pax.gstHst.chd1`,
          Number(updateData?.hotel.hotel_from_pax?.gstHst?.chd1)
        );
        setValue(
          `hotel.hotel_from_pax.gstHst.inf1`,
          Number(updateData?.hotel.hotel_from_pax?.gstHst?.inf1)
        );
        setValue(
          `hotel.hotel_from_pax.taxes.adt1`,
          Number(updateData?.hotel.hotel_from_pax?.taxes?.adt1)
        );
        setValue(
          `hotel.hotel_from_pax.taxes.chd1`,
          Number(updateData?.hotel.hotel_from_pax?.taxes?.chd1)
        );
        setValue(
          `hotel.hotel_from_pax.taxes.inf1`,
          Number(updateData?.hotel.hotel_from_pax?.taxes?.inf1)
        );
        setValue(
          `hotel.hotel_from_pax.amountPaid`,
          Number(updateData?.hotel.hotel_from_pax?.amountPaid)
        );

        setValue(
          `hotel.hotel_from_pax.refund`,
          Number(updateData?.hotel.hotel_from_pax?.refund)
        );
        setValue(
          `hotel.hotel_from_pax.refund_paid`,
          Number(updateData?.hotel.hotel_from_pax?.refund_paid)
        );

        setValue(
          `hotel.hotel_from_pax.payment_received_from_pax`,
          toBoolean(updateData?.hotel.hotel_from_pax?.payment_received_from_pax)
        );
        // Using supplierPax for the key and when accessing updateData
        setValue(
          `hotel.hotel_to_supplier.baseFare.adt1`,
          Number(updateData?.hotel.hotel_to_supplier?.baseFare?.adt1)
        );
        setValue(
          `hotel.hotel_to_supplier.baseFare.chd1`,
          Number(updateData?.hotel.hotel_to_supplier?.baseFare?.chd1)
        );
        setValue(
          `hotel.hotel_to_supplier.baseFare.inf1`,
          Number(updateData?.hotel.hotel_to_supplier?.baseFare?.inf1)
        );
        setValue(
          `hotel.hotel_to_supplier.gstHst.adt1`,
          Number(updateData?.hotel.hotel_to_supplier?.gstHst?.adt1)
        );
        setValue(
          `hotel.hotel_to_supplier.gstHst.chd1`,
          Number(updateData?.hotel.hotel_to_supplier?.gstHst?.chd1)
        );
        setValue(
          `hotel.hotel_to_supplier.gstHst.inf1`,
          Number(updateData?.hotel.hotel_to_supplier?.gstHst?.inf1)
        );

        setValue(
          `hotel.hotel_to_supplier.paymentMade`,
          Number(updateData?.hotel.hotel_to_supplier?.paymentMade)
        );
        setValue(
          `hotel.hotel_to_supplier.payment_received_from_supplier`,
          Number(
            updateData?.hotel.hotel_to_supplier?.payment_received_from_supplier
          )
        );
        setValue(
          `hotel.hotel_to_supplier.recall_commission_to_supplier`,
          Number(
            updateData?.hotel?.hotel_to_supplier?.recall_commission_to_supplier
          )
        );
        setValue(
          `hotel.hotel_to_supplier.refund`,
          Number(updateData?.hotel?.hotel_to_supplier?.refund)
        );
        setValue(
          `hotel.hotel_to_supplier.cash_in_hand`,
          Number(updateData?.hotel?.hotel_to_supplier?.cash_in_hand)
        );

        setValue(
          `hotel.hotel_to_supplier.refund_received_from_supplier`,
          toBoolean(
            updateData?.hotel?.hotel_to_supplier?.refund_received_from_supplier
          )
        );
        setValue(
          `hotel.hotel_to_supplier.payment_received_from_supplier`,
          Number(
            updateData?.hotel?.hotel_to_supplier?.payment_received_from_supplier
          )
        );
        setValue(
          `hotel.hotel_to_supplier.commission_from_supplier`,
          updateData?.hotel?.hotel_to_supplier?.commission_from_supplier
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCountries();
    getSuppliers();
  }, []);

  return (
    <section className="p-2">
      <div>
        <p className="bg-[#ff4e41] px-2 text-white">Hotel:</p>
      </div>

      <div className="grid grid-cols-2 gap-x-2 sm:grid-cols-3">
        {/* Package Name Field */}
        <InputField
          label="Hotel Name"
          id="hotel_name"
          type="text"
          placeholder="Enter Package Name"
          register={register}
          name="hotel.hotelDetails.hotel_name"
          rules={{ required: "Package Name is required" }}
          errorMessage={errors?.hotel?.hotelDetails?.hotel_name?.message}
          onChange={() => clearErrors("hotel.hotelDetails.hotel_name")}
          bgAllDark={true}
        />
        <div>
          <label className="my-2 block text-sm font-medium text-[#ff4e41]">
            Country
          </label>
          <Select
            {...register(`hotel.hotelDetails.country`, {
              required: "Country is required",
            })}
            value={counties.find(
              (source) => source.value === watch("hotel.hotelDetails.country") // Use watch to get the current value
            )} // Controlled value
            onChange={(selectedOption) => {
              setValue(
                "hotel.hotelDetails.country",
                selectedOption?.value || ""
              ); // Update handler using setValue from React Hook Form
              clearErrors("hotel.hotelDetails.country");
            }}
            options={counties} // Format options
            isSearchable={true} // Enable search functionality
            placeholder="Select..."
            classNames={getSelectClassNames({
              isDisabled: false,
              selectProps: {},
              isSelected: false,
              value: watch("hotel.hotelDetails.country"), // Use watch to get the current value
            })} // Pass parameters here
            formatOptionLabel={(data) => (
              <li
                className={`mb-1 block cursor-pointer select-none truncate rounded px-2 py-2 transition duration-200 ${
                  !data.isSelected
                    ? `bg-gray-200 text-gray-900`
                    : `bg-blue-800 text-gray-200`
                }`}
              >
                {data.label}
              </li>
            )}
          />
          {errors?.hotel?.hotelDetails?.country && (
            <span className="text-sm text-red-500">
              {errors?.hotel?.hotelDetails?.country?.message}
            </span>
          )}
        </div>

        {/* Start Date Field */}
        <InputField
          label="Start Date"
          id="start_date"
          type="date"
          register={register}
          name="hotel.hotelDetails.start_date"
          rules={{ required: "Start Date is required" }}
          errorMessage={errors?.hotel?.hotelDetails?.start_date?.message}
          onChange={() => clearErrors("hotel.hotelDetails.start_date")}
          bgAllDark={true}
        />

        {/* End Date Field */}
        <InputField
          label="End Date"
          id="end_date"
          type="date"
          register={register}
          name="hotel.hotelDetails.end_date"
          rules={{ required: "End Date is required" }}
          errorMessage={errors?.hotel?.hotelDetails?.end_date?.message}
          onChange={() => clearErrors("hotel.hotelDetails.end_date")}
          bgAllDark={true}
        />

        {/* Operator Field */}
        <InputField
          label="Operator"
          type="text"
          placeholder="Enter Operator"
          register={register}
          name="hotel.hotelDetails.operator"
          // rules={{ required: "Operator is required" }}
          // errorMessage={errors?.hotel?.hotelDetails?.operator?.message}
          // onChange={() => clearErrors("hotel.hotelDetails.operator")}
          bgAllDark={true}
        />
      </div>

      <div className="mt-4">
        <Calculation
          supplierData={supplierData}
          register={register}
          errors={errors}
          clearErrors={clearErrors}
          watch={watch}
          setValue={setValue}
          control={control}
          getValues={getValues}
          hotel={hotel}
          hotelPax={true}
          hotelSupplier={true}
          updateData={updateData}
        />
      </div>
    </section>
  );
};

export default HotelForm;
